import PropTypes from 'prop-types';
import React, { useState } from 'react';
import CustomModal from 'commons/modal/CustomModal';
import GenericGrid from 'pages/tables/GenericGrid';
import ConfirmationModal from 'commons/modal/ConfirmationModal';
import { useGetAmbianceQuery } from '../../../../redux/api/cache';

export default function AddAmbianceAssignesModal(props) {
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(undefined);

  const { data: ambiances } = useGetAmbianceQuery();

  const campaignClick = (rowData) => {
    setSelectedRow(rowData);

    setDeleteModalVisible(true);
  };

  const submit = () => {
    if (!props.annonce) {
      props.create({
        amb_seq: selectedRow.amb_seq,
        camp_seq: props.infos.camp_seq,
        media_cd: props.infos.media_cd,
        campr_date: props.infos.campr_date,
        diff_cd: props.infos.diff_cd,
        div_num: 0,
        usr_cd: props.infos.usr_cd,
        mf_format: props.infos.mf_format,
      });
    }
    else {
      props.create({
        ann_seq: props.infos.ann_seq,
        amb_seq: selectedRow.amb_seq,
      });
    }
    props.toggleDialog();
  };

  return (
    <div>
      <CustomModal
        width={'45%'}
        title="Ajout d'une ambiance"
        onClose={props.toggleDialog}
        body={
          <div>
            {ambiances !== undefined && (
              <GenericGrid
                autoSize={true}
                take={20}
                rowClicked={campaignClick}
                definition={ambiances.meta.definition}
                data={ambiances.data}
              ></GenericGrid>
            )}
            {deleteModalVisible && (
              <ConfirmationModal
                text={`Ajouter l'ambiance : ${selectedRow.descr} ?`}
                onClose={() => {
                  setDeleteModalVisible(false);
                }}
                onConfirm={() => {
                  setDeleteModalVisible(false);
                  submit();
                }}/>
            )}
          </div>
        }
      />
    </div>
  );
}

AddAmbianceAssignesModal.propTypes = {
  infos: PropTypes.any,
  create: PropTypes.any,
  annonce: PropTypes.bool,
  toggleDialog: PropTypes.func,
};
